import helpers from '@/helpers'

let helper = new Object()

helper.date = (data) => {
  // if(!data) return null;
  // return `${data.substring(8,10)}.${data.substring(5,7)}.${data.substring(0,4)}`;
  return helpers.date.date(data)
}

helper.datetime = (data) => {
  return helpers.date.datetime(data)
}

helper.phone = (phone) => {
  if (!phone) return null
  return `${phone.substring(0, 2)}(${phone.substring(2, 5)})${phone.substring(5, 8)}-${phone.substring(8, 10)}-${phone.substring(10, 12)}`
}

helper.array = (data) => {
  if (!data) return null
  return data.join(', ')
}

helper.ver = (data) => {
  return `v. ${data}`
}

helper.interval = (data) => {
  let sec = Math.round(data / 1000)
  let min = Math.round(sec / 60)
  let hour = Math.round(min / 60)
  if (sec < 60) return `${sec} сек.`
  if (min < 60) return `${min} мин.`
  return `${hour} час.`
}

helper.price = (data) => {
  return `${data} руб.`
}

helper.bonus = (data) => {
  return `${data} бал.`
}

helper.sale = (data) => {
  return `${data * 100} %`
}

helper.cellHandler = (value, data, type, handler) => {
  if (handler) return handler(data)
  if (type == 'date') return helper.date(value)
  if (type == 'datetime') return helper.datetime(value)
  if (type == 'phone') return helper.phone(value)
  if (type == 'array') return helper.array(value)
  if (type == 'ver') return helper.ver(value)
  if (type == 'interval') return helper.interval(value)
  if (type == 'price') return helper.price(value)
  if (type == 'bonus') return helper.bonus(value)
  if (type == 'sale') return helper.sale(value)
  return value
}

export default helper
